<template>
  <table class="table table-hover">
    <thead>
      <th>{{ $t('shared.component.table.field.title') }}</th>
      <th class="w-25">{{ $t('shared.component.table.actions') }}</th>
    </thead>
    <tbody>
      <tr
        v-for="(file, index) in upload_list"
        :key="index"
        @click="show_preview(`img_${index}`, file)"
      >
        <td>{{ file.name }}</td>
        <td>
          <template v-if="file.is_preview">
            <silentbox-single :key="index" :ref="`img_${index}`" :src="file.blob">
              <div></div>
            </silentbox-single>
          </template>
          <i-button icon="ios-trash-outline" @click.stop="remove_file(file)">
            {{ $t('shared.component.table.action.delete') }}
          </i-button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import SilentboxSingle from 'vue-silentbox/components/single';
  export default {
    components: {
      SilentboxSingle
    },
    props: {
      upload_list: {
        type: Array,
        required: true
      }
    },
    methods: {
      show_preview(ref, file) {
        if (file.is_preview) {
          const current_img = this.$refs[ref];
          if (current_img) {
            current_img[0].openSilentBoxOverlay();
          }
        }
      },
      remove_file(file) {
        this.$emit('remove_file', file);
      }
    }
  };
</script>
